/*
 * 计划与报告模块接口
 */

import { post, get, put, del } from 'api/http'

export default {
    // 获取故障报修-合同列表
    getMendContractList(data) {
        return get('/app/party_a/contract/list', data)
    },

    // 获取报修单记录
    getMendLog(data) {
        return get('/app/party_a/repair_record', data)
    },

    // 故障保修详情
    getMendDetail(data) {
        return get('/app/party_a/repair_record', data)
    },

    // 添加报修单
    addMend(data) {
        return post('/app/party_a/repair_record', data)
    },

    // 更新故障报修
    updateMend(data) {
        return put('/app/party_a/repair_record', data)
    },

    // 撤销报修
    revokeMend(data) {
        return put('/app/party_a/repair_record/cancel', data)
    },

    // 删除报修
    deleteMend(data) {
        return del('/app/party_a/repair_record', data)
    },

    // 提交维修登记
    addMendRegister(data) {
        return put('/app/party_a/repair_record/register', data)
    },

    // 提交验收登记
    addMendAccept(data) {
        return put('/app/party_a/repair_record/check', data)
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/mend.js